import ValidationException from "../../exceptions/validationException";
import Notification from "../../utilities/notification"

export default class ValidationModule {

    formData = null;
    locale = null;
    settings = null;
    isValidate = true;
    notification = null;

    constructor(formData, locale, settings) {
        this.formData = formData;
        this.locale = locale;
        this.settings = settings;
        this.notification = new Notification();
    }

    validateName = () => {
        const { name } = this.formData;

        if (!this.isset(name.value)) {
            this.addInputError(name, this.locale.emptyName);
        } else if (name.value.length < 3) {
            this.addInputError(name, this.locale.minimumNumberOfCharactersRequired + ' 3 !');
        } else if (name.value.length > 40) {
            this.addInputError(name, this.locale.maximumNumberOfCharactersRequired + ' 40 !');
        } else {
            this.removeInputError(name);
        }
    }

    validateSurame = () => {
        const { surname } = this.formData;

        if (!this.isset(surname.value)) {
            this.addInputError(surname, this.locale.emptySurname);
        } else if (surname.value.length < 3) {
            this.addInputError(surname, this.locale.minimumNumberOfCharactersRequired + ' 3 !');
        } else if (surname.value.length > 40) {
            this.addInputError(surname, this.locale.maximumNumberOfCharactersRequired + ' 40 !');
        } else {
            this.removeInputError(surname);
        }
    }

    validateEmail = () => {
        const { email } = this.formData;
        const { regex, checkUserEmailExistsUrl, skipLogin } = this.settings;

        return new Promise(async (resolve, reject) => {
            if (email.value.length > 40) {
                this.addInputError(email, this.locale.maximumNumberOfCharactersRequired + ' 40 !');
            } else if (this.isset(email.value) && regex.email.test(email.value)) {
                const formData = `email=${encodeURIComponent(email.value)}`;
                const response = await fetch(checkUserEmailExistsUrl, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'X-Requested': 'With: XMLHttpRequest'
                    }
                });
                const res = await response.text();
                this.removeInputError(email);

                if (!skipLogin) {
                    switch (res) {
                        case '0':
                            resolve();
                            break;
                        case '1':
                            modal.open('login');
                            reject(new ValidationException(this.locale.userNotLogin));
                            break;
                        case '2':
                            reject(new ValidationException(this.locale.emailNotActive));
                            break;
                        case '3':
                            reject(new ValidationException(this.locale.wrongRegisterDnsServer));
                            break;
                        default:
                            reject(new ValidationException(this.locale.wrongEmail));
                            break;
                    }
                }
            } else {
                this.addInputError(email, this.locale.wrongEmail);
            }

            resolve();
        });
    }

    validatePhoneNumber = () => {
        const { phoneNumber } = this.formData;
        const { regex } = this.settings;

        if (this.isset(phoneNumber.value) && regex.phoneNumber.test(phoneNumber.value)) {
            this.removeInputError(phoneNumber);
        } else {
            this.addInputError(phoneNumber, this.locale.wrongPhoneNumber);
        }
    }

    validateCountOfPerson = () => {
        const { countOfPerson } = this.formData;

        if (!this.isset(countOfPerson.value)) {
            this.addInputError(countOfPerson, this.locale.wrongCountOfPerson);
        } else {
            this.removeInputError(countOfPerson);
        }
    }

    validateArrivalTime = () => {
        const { arrivalTime } = this.formData;

        if (!this.isset(arrivalTime.value)) {
            this.addInputError(arrivalTime, this.locale.wrongArrivalTime);
        } else {
            this.removeInputError(arrivalTime);
        }
    }

    validateTaxNumber = () => {
        const { taxNumber } = this.formData;
        const { regex } = this.settings;

        if (this.isset(taxNumber.value) && regex.taxNumber.test(taxNumber.value)) {
            this.removeInputError(taxNumber);
        } else {
            this.addInputError(taxNumber, this.locale.wrongTaxNumber);
            // throw new ValidationException(this.locale("wrongTaxNumber"));
        }
    }

    validateNameOnInvoice = () => {
        const { nameOnInvoice } = this.formData;

        if (!this.isset(nameOnInvoice.value) || nameOnInvoice.value.length > 256) {
            this.addInputError(nameOnInvoice, this.locale.emptyNameOnInvoice);
        } else {
            this.removeInputError(nameOnInvoice);
        }
    }

    validateStreet = () => {
        const { street } = this.formData;

        if (!this.isset(street.value) || street.value.length > 40) {
            this.addInputError(street, this.locale.emptyStreet);
        } else {
            this.removeInputError(street);
        }
    }

    validatePostCode = () => {
        const { postCode } = this.formData;
        const { regex } = this.settings;

        if (this.isset(postCode.value) && regex.postCode.test(postCode.value)) {
            this.removeInputError(postCode);
        } else {
            this.addInputError(postCode, this.locale.wrongPostCode);
        }
    }

    validateCity = () => {
        const { city } = this.formData;

        if (!this.isset(city.value) || city.value.length > 40) {
            this.addInputError(city, this.locale.emptyCity);
        } else {
            this.removeInputError(city);
        }
    }

    validateCountryId = () => {
        const { countryId } = this.formData;

        if (!this.isset(countryId.value)) {
            this.addInputError(countryId, this.locale.emptyCountryId);
        } else {
            this.removeInputError(countryId);
        }
    }

    addInputError = (input, message) => {
        if (input !== null) {
            input.parentElement.querySelector('.input__description')?.remove();
            input.parentElement.classList.add('input--error');
            input.parentElement.appendChild(this.getErrorElement(message));
            this.isValidate = false;
        }
    }

    removeInputError = (input) => {
        input.parentElement.querySelector('.input__description')?.remove();
        input.parentElement.classList.remove('input--error');
    }

    getErrorElement = (message) => {
        const p = document.createElement('p');
        p.classList.add('input__description');
        p.innerHTML = message;

        return p;
    }

    isset = (value) => {
        return !(!value || value === undefined || value === "" || value.length === 0 || value == null || value === null);
    }
}